var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diabetes-state"},[(_vm.diabetesState === 1)?[_vm._v("Tiền tiểu đường")]:_vm._e(),(_vm.diabetesState === 2)?[_vm._v("Loại 1")]:_vm._e(),(_vm.diabetesState === 3)?[_vm._v("Loại 2")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }